import { COMMON_CONSTS } from '../common/common.consts'

export const CRUD_CONSTS = {
  moduleName: 'epb-crud',

  getters: {
    state: 'state',
  },
  actions: {
    ...COMMON_CONSTS.actions,
    list: 'list',
    create: 'create',
    read: 'read',
    update: 'update',
    delete: 'delete',

    fetchData: 'fetchData',
    tag: 'tag',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
    setState: 'setState',
  },
}
